import { SearchState } from '../../../models';
import { DEFAULT_SORT, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class ClearSearchMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.clearPage]: (searchState: SearchState) => {
      searchState.page = 1;
    },
    [SEARCH_MUTATIONS_KEYS.clearPartialResults]: (searchState: SearchState) => {
      searchState.partialResults = [];
    },
    [SEARCH_MUTATIONS_KEYS.clearSearch]: (searchState: SearchState) => {
      searchState.banners = [];
      searchState.facets = {};
      searchState.numFound = 0;
      searchState.page = 1;
      searchState.partialResults = [];
      searchState.promoteds = [];
      searchState.query = '';
      searchState.results = [];
      searchState.sort = DEFAULT_SORT;
      searchState.spellcheck = '';
    }
  };
}
